













































import Vue from "vue";
import StuntSheet from "@/models/StuntSheet";
import DotAppearance from "@/models/DotAppearance";

/**
 * Renders a single dot
 */
export default Vue.extend({
  name: "Dot",
  props: {
    dotTypeIndex: Number,
    label: String,
    labeled: Boolean,
    selected: Boolean,
  },
  computed: {
    radius(): number {
      return 0.7;
    },
    dotAppearance(): DotAppearance {
      const currentSS: StuntSheet = this.$store.getters.getSelectedStuntSheet;
      return currentSS.dotAppearances[this.dotTypeIndex];
    },
  },
});
